/* Coolkidz Circle brand bonus: when a Circle code is on the cart and that ambassador has a bonus code (CIRCLE-NAME-PLUS,
   e.g. extra off one brand), add it next to their main code. The two codes cover different products, so both apply. */
(function () {
  if (!window.fetch) return;
  var post = function (body) { return fetch("/cart/update.js", { method: "POST", headers: { "Content-Type": "application/json", accept: "application/json" }, body: JSON.stringify(body) }).then(function (r) { return r.json(); }); };
  fetch("/cart.js", { headers: { accept: "application/json" } }).then(function (r) { return r.json(); }).then(function (cart) {
    var codes = (cart.discount_codes || []).map(function (d) { return String(d.code).toUpperCase(); });
    var main = codes.filter(function (c) { return /^CIRCLE-/.test(c) && !/-PLUS$/.test(c); })[0];
    if (!main || codes.indexOf(main + "-PLUS") > -1) return;
    var key = "ck_plus_" + main, known = null;
    try { known = sessionStorage.getItem(key); } catch (e) {}
    if (known === "none") return;
    (known ? Promise.resolve({ plus: known }) : fetch("https://circle.coolkidz.com.au/api/public-circle?plus=" + encodeURIComponent(main)).then(function (r) { return r.json(); }))
      .then(function (j) {
        try { sessionStorage.setItem(key, j && j.plus ? j.plus : "none"); } catch (e) {}
        if (j && j.plus) return post({ discount: codes.concat([j.plus]).join(",") });
      }).catch(function () {});
  }).catch(function () {});
})();
